import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";

const BanksChoose_PointCommission = () => {
  const session_id = Cookies.get("jwt");

  const [upload, setUpload] = useState({
    idcard_image: [],
    bankbook_image: [],
    bankName: null,
    bankAccountNumber: null,
    nameOwnerBank: null,
    email: null,
    address: null,
  });
  const { idcard_image, bankbook_image, bankName, nameOwnerBank, bankAccountNumber, email, address } = upload;
  const [isUploading, setIsUploading] = useState(false);
  const [statusUploaded, setStatusUploaded] = useState(false);
  const [credentialStatus, setCredentialStatus] = useState(null);

  useEffect(() => {
    const token = Cookies.get("jwt");
    axios
      .get(`${process.env.REACT_APP_API}/banking/getCredential`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.data?.status === "approved" || res.data?.status === "pending") {
          setStatusUploaded(true);
          setCredentialStatus(res.data.status);
        }
      })
      .catch(() => {});
  }, []);

  const handleIDCardAuth = async (e) => {
    setUpload({ ...upload, idcard_image: Array.from(e.target.files) });
  };

  const handleBookBankAuth = async (e) => {
    setUpload({ ...upload, bankbook_image: Array.from(e.target.files) });
  };

  const handleBankSelect = (e) => {
    setUpload({ ...upload, bankName: e.target.value });
  };

  const inputValue = (name) => (e) => {
    setUpload({ ...upload, [name]: e.target.value });
  };

  const handleUploadData = (e) => {
    e.preventDefault();
    setIsUploading(true);
    const token = Cookies.get("jwt");
    const formData = new FormData();
    formData.append("bank", bankName);
    formData.append("bankBookId", bankAccountNumber);
    formData.append("fullname", nameOwnerBank);
    if (email) formData.append("email", email);
    if (address) formData.append("address", address);
    idcard_image.forEach((f) => formData.append("idcard_image[]", f));
    bankbook_image.forEach((f) => formData.append("bankbook_image[]", f));
    axios
      .post(
        `${process.env.REACT_APP_API}/banking/addCredential`,
        formData,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
      )
      .then(async () => {
        await Swal.fire("อัปโหลดเอกสารเรียบร้อย", "กำลังรอการตรวจสอบภายใน 3-5 วันทำการ", "success");
        setIsUploading(false);
        localStorage.setItem("isSentDocumentWithDrawMoney", true);
        window.location.replace("/user/point");
      })
      .catch((error) => {
        setIsUploading(false);
        Swal.fire("เกิดข้อผิดพลาด", `${error.response.data.Error}`, "error");
      });
  };

  const inputCls = "w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-blue-400 focus:bg-white transition-colors";
  const labelCls = "block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5";

  const bankList = [
    "กสิกรไทย","กรุงเทพ","กรุงไทย","กรุงศรี","ซีไอเอ็มบี","ทหารไทยธนชาต",
    "ไทยพาณิชย์","ยูโอบี","แลนด์ แอนด์ เอ้าส์","สแตนดาร์ดฯ","ออมสิน",
    "เกียรตินาคินภัทร","ซิตี้แบงก์","อาคารสงเคราะห์","ธ.ก.ส","มิซูโฮ",
    "ธ.อิสลาม","ทิสโก้","ไอซีบีซี(ไทย)","ไทยเครดิต","ซูมิโตโม มิตชุย",
    "เอชเอสบีซี","บีเอ็นพี พารีบาล์","ดอยช์แบงก์ เอจี",
  ];

  const UploadBox = ({ label, hint, images, onFileChange, fieldName }) => (
    <div>
      <label className={labelCls}>{label}</label>
      <div className="relative w-full h-44 bg-gray-50 border-2 border-dashed border-gray-200 rounded-xl overflow-hidden hover:border-blue-300 transition-colors">
        {images.length > 0 ? (
          <img
            src={URL.createObjectURL(images[images.length - 1])}
            className="w-full h-full object-contain"
            alt="preview"
          />
        ) : (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 pointer-events-none">
            <div className="w-10 h-10 bg-gray-100 rounded-xl flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
              </svg>
            </div>
            <p className="text-xs text-gray-400 text-center px-4">{hint}</p>
          </div>
        )}
        <input
          type="file"
          name={fieldName}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
          accept="image/png, image/jpeg, image/jpg"
          onChange={onFileChange}
          multiple
        />
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-lg mx-auto px-4 py-8 space-y-4">

        {/* ── Header ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="flex items-center gap-3"
        >
          <button
            onClick={() => window.location.replace("/user/point")}
            className="w-9 h-9 bg-white rounded-xl flex items-center justify-center border border-gray-200 shadow-sm hover:bg-gray-50 transition-colors flex-shrink-0"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <div>
            <p className="text-xs text-gray-400 uppercase tracking-wider">คอมมิชชั่น</p>
            <h1 className="text-lg font-bold text-gray-900">เอกสารการรับเงิน</h1>
          </div>
        </motion.div>

        {/* ── Already uploaded ── */}
        {statusUploaded ? (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.05 }}
            className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 flex flex-col items-center text-center gap-4"
          >
            <div className="w-16 h-16 bg-emerald-50 rounded-2xl flex items-center justify-center">
              <CheckCircle className="w-8 h-8 text-emerald-500" />
            </div>
            <div>
              <p className="text-base font-bold text-gray-800">
                {credentialStatus === "approved" ? "เอกสารได้รับการอนุมัติแล้ว" : "ส่งเอกสารเรียบร้อยแล้ว"}
              </p>
              <p className="text-sm text-gray-400 mt-1">
                {credentialStatus === "approved"
                  ? "หากต้องการเปลี่ยนแปลงข้อมูล กรุณาติดต่อ Admin หรือ Call Center"
                  : "เอกสารอยู่ระหว่างการตรวจสอบ กรุณารอ 3-5 วันทำการ"}
              </p>
            </div>
          </motion.div>
        ) : (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.05 }}
            className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden"
          >
            <div className="px-5 py-3.5 border-b border-gray-100">
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">กรอกข้อมูลการรับเงิน</p>
            </div>
            <form onSubmit={handleUploadData} className="px-5 py-5 space-y-4">

              <UploadBox
                label="บัตรประจำตัวประชาชน"
                hint="อัปโหลดรูปบัตรประชาชนเพื่อประกอบการหักภาษี ณ ที่จ่าย"
                images={idcard_image}
                onFileChange={handleIDCardAuth}
                fieldName="idcard_image"
              />

              <UploadBox
                label="หน้าสมุดบัญชีธนาคาร"
                hint="อัปโหลดรูปหน้าบัญชีธนาคารเพื่อรับโอนเงิน"
                images={bankbook_image}
                onFileChange={handleBookBankAuth}
                fieldName="bankbook_image"
              />

              <div>
                <label className={labelCls}>ธนาคาร</label>
                <select
                  className={`${inputCls} cursor-pointer`}
                  onChange={handleBankSelect}
                  defaultValue=""
                >
                  <option value="" disabled>เลือกธนาคาร</option>
                  {bankList.map((b, i) => <option key={i}>{b}</option>)}
                </select>
              </div>

              <div>
                <label className={labelCls}>เลขที่บัญชี / หมายเลขพร้อมเพย์</label>
                <input onChange={inputValue("bankAccountNumber")} type="text" inputMode="numeric" placeholder="กรอกเลขที่บัญชี" className={inputCls} />
              </div>

              <div>
                <label className={labelCls}>ชื่อเจ้าของบัญชี</label>
                <input onChange={inputValue("nameOwnerBank")} type="text" placeholder="ชื่อ-นามสกุล เจ้าของบัญชี" className={inputCls} />
              </div>

              <div>
                <label className={labelCls}>อีเมล</label>
                <input onChange={inputValue("email")} type="email" placeholder="example@email.com" className={inputCls} />
              </div>

              <div>
                <label className={labelCls}>ที่อยู่สำหรับจัดส่งเอกสาร</label>
                <input onChange={inputValue("address")} type="text" placeholder="ที่อยู่สำหรับรับเอกสาร" className={inputCls} />
              </div>

              <button
                type="submit"
                disabled={isUploading}
                className="w-full py-3.5 bg-blue-600 text-white text-sm font-semibold rounded-xl hover:bg-blue-700 transition-colors disabled:opacity-70 mt-2"
              >
                {isUploading ? "กำลังอัปโหลด..." : "อัปโหลดข้อมูล"}
              </button>
            </form>
          </motion.div>
        )}

      </div>
    </div>
  );
};

export default BanksChoose_PointCommission;
